import {createStore, applyMiddleware, combineReducers} from 'redux';
import thunk from 'redux-thunk';
import index from "./reducer/index";
import ajax from "./api/ajax";
import {  routerReducer, routerMiddleware } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'

export const history = createHistory();
const middleware = routerMiddleware(history);
console.log(index);
const store = createStore(
    index,
    applyMiddleware(thunk, ajax, middleware)
);

let unsubscribe = store.subscribe(() => {
    console.log(store.getState());
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js